import React from 'react';

const NotificationsHeader = () => {

    return (
        <>

        </>
    );
};

export default NotificationsHeader;